<template>
  <v-simple-table class="medication-quartiles">
    <template v-slot:default>
      <tbody>
        <tr>
          <td
            v-for="(quartile, index) in quartileList"
            :key="`${quartile}-${index}`"
          >{{ $ucfirst($t(`quartiles.${quartile}`)) }}</td>
        </tr>
        <tr>
          <td
            v-for="(quartile, index) in quartileList"
            :key="`${quartile}-${index}`"
          >
            <medication-text-field
              :is-editable="isEditable"
              :error="error && isQuartileError(quartile)"
              is-special-placeholder
              hide-details
              :placeholder="isEditable ? '' : '0'"
              type="Number"
              v-model="self()[quartile]"
              class="medication-quartiles__input"
              :min="0"
              :max="10"
              :style="`max-width: ${(self()[quartile].toString().length || 1) * 10 + 55}px`"
              @onKeypress="onKeypress"
              @onPaste="onPaste($event, quartile)"
            ></medication-text-field>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import MedicationTextField from './MedicationTextField';

/**
 * Component MedicationQuartiles.vue
 *
 * @module MedicationQuartiles
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/templates/components/Parts/Medication/MedicationQuartiles.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'MedicationQuartiles',
  components: {
    MedicationTextField,
  },
  props: {
    morningAmount: {
      type: [Number, String],
      required: true,
    },
    noonAmount: {
      type: [Number, String],
      required: true,
    },
    afternoonAmount: {
      type: [Number, String],
      required: true,
    },
    eveningAmount: {
      type: [Number, String],
      required: true,
    },
    isEditable: {
      type: Boolean,
      required: true,
    },
    error: {
      type: Boolean,
      default: () => false,
    },
    errorList: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      quartileList: [
        'morning',
        'noon',
        'afternoon',
        'evening',
      ],
    };
  },
  computed: {
    morning: {
      get() {
        return (this.morningAmount || this.isEditable) ? this.morningAmount : '';
      },
      set(morningAmount) {
        this.$emit('update:morningAmount', morningAmount.replace(',', '.'));
      },
    },
    noon: {
      get() {
        return (this.noonAmount || this.isEditable) ? this.noonAmount : '';
      },
      set(noonAmount) {
        this.$emit('update:noonAmount', noonAmount.replace(',', '.'));
      },
    },
    afternoon: {
      get() {
        return (this.afternoonAmount || this.isEditable) ? this.afternoonAmount : '';
      },
      set(afternoonAmount) {
        this.$emit('update:afternoonAmount', afternoonAmount.replace(',', '.'));
      },
    },
    evening: {
      get() {
        return (this.eveningAmount || this.isEditable) ? this.eveningAmount : '';
      },
      set(eveningAmount) {
        this.$emit('update:eveningAmount', eveningAmount.replace(',', '.'));
      },
    },
  },
  methods: {
    self() {
      return this;
    },
    isQuartileError(quartile) {
      return !!this.errorList.includes(quartile)
    },
    onKeypress(event) {
      const onlyNumbers = /[\d,.]/
      if (!onlyNumbers.test(event.key)) {
        event.preventDefault();
      }
    },
    onPaste(event, key) {
      const pasted = event.clipboardData.getData('text/plain')
      const parsed = parseFloat(pasted)
      event.preventDefault()

      if (!isNaN(parsed) && !(parsed < 0)) {
        const replaced = pasted.replaceAll(',','.')
        this.$emit(`update:${key}Amount`, parseFloat(replaced));
      } else {
        this.$emit(`update:${key}Amount`, 0);
      }
    }
  },
};
</script>

<style lang="scss">
.medication-quartiles {
  background: transparent !important;
  margin-left: 50px;

  table > tbody > tr:hover {
    background-color: transparent !important;
  }

  td {
    font-size: 0.9rem !important;
    font-weight: 600;
    white-space: nowrap;
    padding-right: 32px;
    text-align: center;
    min-width: 200px;
  }

  .v-text-field {
    margin-top: 16px;
    width: 220px;
  }
}

.medication-quartiles__input {
  width: 100%;
  min-width: 75px;
  display: inline-block;

  input {
    text-align: center;
  }
}
</style>
